import React from 'react'
import Navbar from '../../landing/sections/Navbar'
import MobileBanner from './MobileBanner'
import FooterSection from '../../landing/sections/FooterSection'
import ServiceSectionMobile from './ServiceSectionMobile'
import MobileFeatureSection from './MobileFeatureSection'
import SaleSectionMobile from './SaleSectionMobile'
import TradingFeaturesMobile from './TradingFeaturesMobile'
import MobileTestimonialSection from './MobileTestimonialSection'
import ScrollToTop from '../../../components/ScrollToTop/ScrollToTop'

const MobileLanding = () => {

    return (
        <div>
            <Navbar />
            <MobileBanner />
            <ServiceSectionMobile />
            <MobileFeatureSection />
            <SaleSectionMobile />
            <TradingFeaturesMobile />
            <MobileTestimonialSection />
            <ScrollToTop />
            <FooterSection />
        </div>
    )
}

export default MobileLanding